import $ from "jquery";

const $window = $(window);
const $header = $(".header");

export const isInt = (n) => Number(n) === n && n % 1 === 0;

export const isFloat = (n) => Number(n) === n && n % 1 !== 0;

export function getScrollBarWidth() {
  const $outerEl = $("<div>")
    .css({
      visibility: "hidden",
      width: 100,
      overflow: "scroll",
    })
    .appendTo("body");
  const widthWithScroll = $("<div>")
    .css({
      width: "100%",
    })
    .appendTo($outerEl)
    .outerWidth();
  $outerEl.remove();
  return 100 - widthWithScroll;
}

export const getWindowWidth = () => $window.width() - getScrollBarWidth();

export const getHeaderHeight = () => $header.outerHeight();

export const getVh = () => window.innerHeight * 0.01;

export const getDefaultFontSize = () =>
  parseFloat(
    window.getComputedStyle(document.body, null).getPropertyValue("font-size")
  );

export const pxToRem = (num) => num / getDefaultFontSize() + "rem";

export function debounce(
  callback,
  execOnLeadingEdge = false,
  debounceDelay = 200
) {
  let timeout;

  return function debounced() {
    let obj = this;
    let args = arguments;

    function delayed() {
      if (!execOnLeadingEdge) {
        callback.apply(obj, args);
      }
      timeout = null;
    }

    if (timeout) {
      clearTimeout(timeout);
    } else if (execOnLeadingEdge) {
      callback.apply(obj, args);
    }

    timeout = setTimeout(delayed, debounceDelay);
  };
}

export const flipSign = (n) => (isInt(n) || isFloat(n) ? -1 * n : n);

export const getVideoId = (rawUrl) => {
  const url = new URL(rawUrl);
  let slug = false;

  if (url.search) {
    if (url.searchParams.get("v")) {
      slug = url.searchParams.get("v");
    } else if (url.searchParams.get("vi")) {
      slug = url.searchParams.get("vi");
    }
  }
  if (url.pathname && slug === false) {
    const path = url.pathname.trim("/").split("/");
    slug = path[path.length - 1];
  }

  return slug;
};

export const isOverflown = (element) =>
  isVerticalOverflown(element) || isHorizontalOverflown(element);

export const isVerticalOverflown = (element) =>
  element.scrollHeight > element.clientHeight;

export const isHorizontalOverflown = (element) =>
  element.scrollWidth > element.clientWidth;

export const delay = (time) =>
  new Promise((resolve) => setTimeout(() => resolve("done"), time));

export const safe$ = (element) => {
  if (
    typeof element === "string" ||
    typeof element === "object" ||
    element instanceof $
  ) {
    (typeof element === "string" || typeof element === "object") &&
      (element = $(element));
    return element;
  } else {
    return false;
  }
};

export const forceFocus = (element) => {
  if (safe$(element) && !element.is(":focus")) {
    element.get(0).focus({ preventScroll: true });

    if (!element.is(":focus")) {
      element.attr("tabindex", -1);
      element.get(0).focus({ preventScroll: true });
    }
  }
};

export const setInputVal = (element, value, eventType = "change") => {
  element = safe$(element);

  if (element && element.length === 1) {
    const target = element.get(0);

    Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      "value"
    )?.set?.call(target, value);

    if (eventType && typeof eventType === "string") {
      const event = new Event(eventType, { bubbles: true });
      target.dispatchEvent(event);
    }
  }
};

String.prototype.convertNbsp = function () {
  return this.replace(/&nbsp;/g, " ");
};
